import { SvgIcon } from '@mui/material'

const SvgGroups4 = (props) => (
  <SvgIcon viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" name="SvgGroups4" {...props}>
    <style>
      {
        '.groups4_svg__st0{fill:#bfd5de}.groups4_svg__st2{fill:#d3a489}.groups4_svg__st3{fill:#bf8e75}.groups4_svg__st4{fill:#3d4159}.groups4_svg__st5{fill:#fff}.groups4_svg__st6{fill:#2a2f4f}.groups4_svg__st8{fill:#d8d5d0}.groups4_svg__st9{fill:#eab599}.groups4_svg__st10{fill:#f6caae}'
      }
    </style>
    <path
      className="groups4_svg__st0"
      d="M489.023 330.102v32.047c-25.223 55.285-69.539 100.02-124.512 125.785a254.027 254.027 0 01-30.887 12.07 251.557 251.557 0 01-36.902 8.766c-.055.008-.117.02-.168.02V330.102c0-38.086 29.328-69.328 66.652-72.336a69.599 69.599 0 015.934-.242h47.273c5.59 0 11.035.617 16.258 1.82 32.267 7.375 56.352 36.266 56.352 70.758z"
    />
    <path
      d="M489.023 330.102v32.047c-25.223 55.285-69.539 100.02-124.512 125.785a254.027 254.027 0 01-30.887 12.07V330.102c0-40.082 32.508-72.578 72.602-72.578h10.195c40.106 0 72.602 32.496 72.602 72.578z"
      fill="#dde8ed"
    />
    <path
      className="groups4_svg__st2"
      d="M321.738 177.465c0 11.988-8.762 21.93-20.23 23.777-1.25.203-2.543.309-3.855.309-13.309 0-24.086-10.781-24.086-24.086s10.777-24.086 24.086-24.086c1.312 0 2.605.105 3.855.309 11.469 1.848 20.23 11.789 20.23 23.777z"
    />
    <path
      className="groups4_svg__st3"
      d="M321.738 177.465c0 11.988-8.762 21.93-20.23 23.777a89.613 89.613 0 01-3.195-23.777 89.63 89.63 0 013.195-23.777c11.469 1.848 20.23 11.789 20.23 23.777z"
    />
    <path className="groups4_svg__st3" d="M306.262 177.465a8.61 8.61 0 11-17.22-.002 8.61 8.61 0 0117.22.002z" />
    <path
      className="groups4_svg__st0"
      d="M392.781 287.235l-32.684 18.164-9.941-46.242 20.309-11.961M392.781 287.235l32.68 18.164 9.941-46.242-20.305-11.961"
    />
    <path
      className="groups4_svg__st2"
      d="M463.828 177.465c0 11.988 8.758 21.93 20.227 23.777 1.254.203 2.547.309 3.859.309 13.309 0 24.086-10.781 24.086-24.086s-10.777-24.086-24.086-24.086c-1.312 0-2.605.105-3.859.309-11.469 1.848-20.227 11.789-20.227 23.777z"
    />
    <path
      className="groups4_svg__st3"
      d="M463.828 177.465c0 11.988 8.758 21.93 20.227 23.777a89.45 89.45 0 003.199-23.777 89.467 89.467 0 00-3.199-23.777c-11.469 1.848-20.227 11.789-20.227 23.777z"
    />
    <path className="groups4_svg__st3" d="M496.523 177.465a8.61 8.61 0 11-17.22-.002 8.61 8.61 0 0117.22.002z" />
    <path
      className="groups4_svg__st3"
      d="M482.398 164.665c0 44.594-32.578 81.59-75.23 88.457a88.544 88.544 0 01-14.383 1.156c-49.496 0-89.617-40.117-89.617-89.613 0-23.418 8.137-58.574 22.84-74.539 16.379-17.777 40.699-15.078 66.777-15.078 4.898 0 9.703.391 14.383 1.16 42.652 6.867 75.23 43.859 75.23 88.457z"
    />
    <path
      className="groups4_svg__st3"
      d="M418.684 229.555v31.785c0 11.637-7.672 21.473-18.242 24.738a25.844 25.844 0 01-7.66 1.156c-14.305 0-25.898-11.59-25.898-25.895v-31.785h51.8z"
    />
    <path
      className="groups4_svg__st2"
      d="M418.684 259.329v2.012c0 11.637-7.672 21.473-18.242 24.742-9.535-2.934-16.703-11.223-18.027-21.367a88.628 88.628 0 0019.602-1 88.188 88.188 0 0016.667-4.387zM482.398 164.665c0 44.594-32.578 81.59-75.23 88.457-42.656-6.867-75.234-43.863-75.234-88.457 0-27.461 12.352-52.039 31.812-68.48 12.129-10.258 27.035-17.34 43.422-19.98 39.766 6.402 70.781 39 74.789 79.523.293 2.94.441 5.925.441 8.937z"
    />
    <path
      className="groups4_svg__st3"
      d="M392.785 208.801c-7.504 0-15.008-1.883-21.848-5.641-1.93-1.062-2.637-3.484-1.574-5.414s3.484-2.633 5.414-1.574c11.277 6.199 24.738 6.199 36.016 0a3.99 3.99 0 015.414 1.574 3.989 3.989 0 01-1.574 5.414c-6.84 3.758-14.344 5.641-21.848 5.641z"
    />
    <path
      className="groups4_svg__st4"
      d="M373.699 159.446c0 5.617-4.551 10.168-10.164 10.168a10.166 10.166 0 01-10.168-10.168c0-5.613 4.551-10.164 10.168-10.164 5.613 0 10.164 4.551 10.164 10.164zM432.199 159.446c0 5.617-4.551 10.168-10.164 10.168s-10.168-4.551-10.168-10.168c0-5.613 4.555-10.164 10.168-10.164s10.164 4.551 10.164 10.164z"
    />
    <path
      className="groups4_svg__st5"
      d="M371.629 157.653a4.357 4.357 0 01-8.714 0 4.357 4.357 0 018.714 0zM430.629 157.653a4.357 4.357 0 01-8.714 0 4.357 4.357 0 018.714 0z"
    />
    <path
      className="groups4_svg__st3"
      d="M402.949 185.043h-20.332c-2.422 0-4.383-1.965-4.383-4.387s1.961-4.383 4.383-4.383h20.332a4.385 4.385 0 110 8.77z"
    />
    <path className="groups4_svg__st0" d="M422.289 327.723h39.066v11.961h-39.066v-11.961z" />
    <path
      className="groups4_svg__st6"
      d="M387.539 49.446c27.148 1.941 48.945 23.871 50.324 51.477l.258 5.184h15.617l8.41 55.93 20.371-6.305-2.734-54.809c-1.445-28.996-25.43-51.723-54.453-51.617l-37.793.14z"
    />
    <path
      className="groups4_svg__st4"
      d="M478.059 27.817c21.617 21.617 21.617 56.668 0 78.285s-56.668 21.617-78.285 0l78.285-78.285z"
    />
    <path
      className="groups4_svg__st4"
      d="M399.777 106.102h-67.941l-8.414 55.934-20.371-6.305 2.734-54.809c1.441-28.992 25.426-51.727 54.453-51.617l98.121.371 12.973 23.348"
    />
    <path
      className="groups4_svg__st6"
      d="M398.027 49.446c-27.145 1.941-48.941 23.871-50.324 51.477l-.258 5.184h-15.613l-8.414 55.93-20.371-6.305 2.738-54.809c1.441-28.996 25.426-51.723 54.449-51.617l37.793.14z"
    />
    <g>
      <path
        d="M201.293 332.247v173.891c-80.781-17.586-147.32-73.301-179.816-147.352v-26.539c0-31.379 21.305-57.785 50.246-65.516a53.138 53.138 0 013.211-.785 66.062 66.062 0 018.816-1.293c1.828-.148 3.68-.23 5.551-.23h44.168c4.941 0 9.746.52 14.387 1.523.273.055.531.117.793.18.785.176 1.559.363 2.332.574a.372.372 0 00.062.02 67.333 67.333 0 0121.055 9.77c17.648 12.245 29.195 32.651 29.195 55.757z"
        fill="#296f9b"
      />
      <path
        className="groups4_svg__st8"
        d="M111.379 292.188l-30.531 16.969-9.289-43.203 18.973-11.176M111.379 292.188l30.535 16.969 9.289-43.203-18.973-11.176"
      />
      <path
        className="groups4_svg__st9"
        d="M135.582 238.297v29.699c0 10.871-7.168 20.059-17.043 23.109a24.067 24.067 0 01-7.156 1.082c-13.363 0-24.195-10.828-24.195-24.195v-29.695h48.394z"
      />
      <path
        className="groups4_svg__st10"
        d="M135.582 266.114v1.883c0 10.871-7.168 20.059-17.043 23.109-8.906-2.738-15.605-10.484-16.844-19.961a82.76 82.76 0 0018.313-.934 82.12 82.12 0 0015.574-4.097zM45.004 189.629c0 11.203-8.18 20.492-18.895 22.215a22.427 22.427 0 01-3.605.289C10.07 212.133 0 202.063 0 189.629c0-12.43 10.07-22.504 22.504-22.504 1.227 0 2.434.102 3.605.289 10.715 1.727 18.895 11.012 18.895 22.215z"
      />
      <path
        className="groups4_svg__st9"
        d="M45.004 189.629c0 11.203-8.18 20.492-18.895 22.215-1.949-7.078-2.988-14.527-2.988-22.215s1.039-15.137 2.988-22.215c10.715 1.727 18.895 11.012 18.895 22.215z"
      />
      <path
        className="groups4_svg__st9"
        d="M30.547 189.629c0 4.441-3.602 8.043-8.043 8.043s-8.043-3.602-8.043-8.043 3.602-8.043 8.043-8.043 8.043 3.602 8.043 8.043z"
      />
      <path
        className="groups4_svg__st10"
        d="M177.762 189.629c0 11.203 8.184 20.492 18.898 22.215a22.39 22.39 0 003.605.289c12.43 0 22.5-10.07 22.5-22.504 0-12.43-10.07-22.504-22.5-22.504-1.23 0-2.434.102-3.605.289-10.715 1.727-18.898 11.012-18.898 22.215z"
      />
      <path
        className="groups4_svg__st9"
        d="M177.762 189.629c0 11.203 8.184 20.492 18.898 22.215 1.945-7.078 2.984-14.527 2.984-22.215s-1.039-15.137-2.984-22.215c-10.715 1.727-18.898 11.012-18.898 22.215z"
      />
      <path
        className="groups4_svg__st9"
        d="M195.109 145.79v31.883c0 41.664-30.438 76.227-70.289 82.641-.133.023-.277.043-.41.066a82.199 82.199 0 01-13.027 1.016c-46.238 0-83.723-37.484-83.723-83.723V145.79c0-9.738 1.66-19.094 4.73-27.785C43.839 85.423 74.886 62.06 111.382 62.06h.004c4.434 0 8.793.344 13.039 1.012 40.048 6.261 70.684 40.913 70.684 82.718z"
      />
      <path className="groups4_svg__st9" d="M208.305 189.629a8.04 8.04 0 11-16.082 0 8.042 8.042 0 1116.082 0z" />
      <path
        className="groups4_svg__st10"
        d="M195.109 145.79v31.883c0 41.664-30.438 76.227-70.289 82.641-.133.023-.277.043-.41.066-40.047-6.258-70.676-40.91-70.676-82.707V145.79c0-41.805 30.637-76.457 70.691-82.719 40.048 6.262 70.684 40.914 70.684 82.719z"
      />
      <path
        className="groups4_svg__st4"
        d="M93.555 172.797c0 5.242-4.254 9.496-9.5 9.496-5.242 0-9.496-4.254-9.496-9.496 0-5.246 4.254-9.5 9.496-9.5 5.246 0 9.5 4.254 9.5 9.5zM148.211 172.797c0 5.242-4.25 9.496-9.496 9.496s-9.5-4.254-9.5-9.496c0-5.246 4.254-9.5 9.5-9.5s9.496 4.254 9.496 9.5z"
      />
      <path
        className="groups4_svg__st5"
        d="M91.617 171.122a4.066 4.066 0 01-4.07 4.066 4.069 4.069 0 110-8.136 4.067 4.067 0 014.07 4.07zM146.742 171.122c0 2.246-1.824 4.066-4.07 4.066a4.069 4.069 0 114.07-4.066z"
      />
      <path
        className="groups4_svg__st9"
        d="M120.883 192.985h-18.996a4.097 4.097 0 110-8.196h18.996c2.262 0 4.098 1.836 4.098 4.098s-1.836 4.098-4.098 4.098zM111.383 218.907c-7.008 0-14.02-1.758-20.41-5.27a3.726 3.726 0 01-1.469-5.059 3.722 3.722 0 015.059-1.469c10.535 5.789 23.113 5.789 33.648 0a3.718 3.718 0 015.055 1.469 3.723 3.723 0 01-1.469 5.059c-6.391 3.512-13.402 5.27-20.414 5.27z"
      />
      <path
        d="M195.109 116.856v32.66h-15.582v-25.578L67.043 103.036 43.242 98.61v50.906H27.66v-32.66c0-37.23 30.176-67.406 67.398-67.406h32.648c.887 0 1.773.012 2.66.059 35.989 1.382 64.743 31.003 64.743 67.347z"
        fill="#e8c934"
      />
      <path
        d="M195.109 116.856v32.66h-15.582v-25.578L67.043 103.036c6.199-29.766 32.023-52.32 63.324-53.527 35.988 1.382 64.742 31.003 64.742 67.347z"
        fill="#ffe152"
      />
    </g>
    <g>
      <path
        d="M364.66 470.172v17.688c-32.977 15.484-69.809 24.137-108.66 24.137-18.773 0-37.082-2.016-54.707-5.859a254.524 254.524 0 01-57.48-19.969v-15.996c0-38.535 26.164-70.961 61.711-80.469a83.705 83.705 0 0114.774-2.551 81.643 81.643 0 016.812-.27h54.242c6.059 0 11.973.637 17.668 1.871.324.062.66.133.973.207.961.219 1.922.461 2.863.723.031 0 .051 0 .07.008a82.681 82.681 0 0125.863 12.008c21.68 15.035 35.871 40.101 35.871 68.472z"
        fill="#dd3033"
      />
      <path
        d="M364.66 470.172v17.688c-32.977 15.484-69.809 24.137-108.66 24.137-18.773 0-37.082-2.016-54.707-5.859a253.933 253.933 0 01-20.91-5.496v-30.469c0-38.535 26.164-70.961 61.711-80.469a83.705 83.705 0 0114.774-2.551c2.25-.188 4.516-.27 6.812-.27h17.672c6.059 0 11.973.637 17.668 1.871.324.062.66.133.973.207.961.219 1.922.461 2.863.723.031 0 .051 0 .07.008a82.681 82.681 0 0125.863 12.008c21.68 15.035 35.871 40.101 35.871 68.472z"
        fill="#f74f4f"
      />
      <path
        d="M303.137 388.754l-.211.938-26.109 121.469c-6.867.555-13.805.836-20.816.836-8.23 0-16.395-.387-24.438-1.16l-26.039-121.133-.211-.949h97.824z"
        fill="#f2f0ec"
      />
      <path
        className="groups4_svg__st8"
        d="M254.223 420.977l-37.496 20.84-11.41-53.062 23.301-13.723M254.223 420.977l37.5 20.84 11.406-53.062-23.297-13.723"
      />
      <path
        d="M142.266 366.797V241.18c0-12.766 2.129-25.27 6.328-37.168 15.723-44.738 58.176-74.809 105.637-74.809 5.879 0 11.746.457 17.445 1.359 26.078 4.074 50 17.383 67.348 37.477a111.96 111.96 0 0127.184 73.141v125.617"
        fill="#774e32"
      />
      <path
        d="M188.324 246.086c0 44.434 26.016 95.836 40.305 120.711h-86.367V241.18c0-12.762 2.129-25.266 6.328-37.168 15.625-44.48 57.691-74.461 104.824-74.797-34.426.86-65.09 56.086-65.09 116.871z"
        fill="#664a36"
      />
      <path
        className="groups4_svg__st9"
        d="M283.953 354.793v36.469c0 13.352-8.805 24.637-20.93 28.387a29.731 29.731 0 01-8.793 1.328c-16.41 0-29.715-13.305-29.715-29.715v-36.469h59.438z"
      />
      <path
        className="groups4_svg__st10"
        d="M283.953 388.954v2.309c0 13.352-8.805 24.637-20.93 28.387-10.941-3.363-19.168-12.875-20.688-24.516 1.984.121 3.98.18 5.988.18 5.621 0 11.133-.445 16.504-1.324a101.473 101.473 0 0019.126-5.036zM172.715 295.02c0 13.758-10.051 25.168-23.207 27.285-1.441.23-2.918.352-4.43.352-15.266 0-27.637-12.367-27.637-27.637 0-15.266 12.371-27.633 27.637-27.633 1.512 0 2.988.121 4.43.352 13.156 2.117 23.207 13.523 23.207 27.281z"
      />
      <path
        className="groups4_svg__st9"
        d="M172.715 295.02c0 13.758-10.051 25.168-23.207 27.285a102.75 102.75 0 01-3.668-27.285c0-9.441 1.277-18.586 3.668-27.281 13.156 2.117 23.207 13.523 23.207 27.281z"
      />
      <path
        className="groups4_svg__st9"
        d="M154.957 295.02a9.878 9.878 0 01-9.879 9.879c-5.453 0-9.875-4.422-9.875-9.879 0-5.453 4.422-9.875 9.875-9.875 5.457 0 9.879 4.422 9.879 9.875z"
      />
      <path
        className="groups4_svg__st9"
        d="M325.195 259.735v94.996c-14.684 14.016-33.512 23.723-54.461 27.098l-.504.082a101.284 101.284 0 01-16 1.246c-56.785 0-102.82-46.035-102.82-102.82V241.18c0-5.012.359-9.945 1.055-14.766 24.461 17.594 59.539 15.855 81.887-5.27 7.402-6.988 12.543-15.312 15.453-24.141 1.617 15.461 8.691 30.508 21.223 42.355 14.921 14.092 34.636 20.889 54.167 20.377z"
      />
      <path
        className="groups4_svg__st10"
        d="M325.195 259.735v94.996c-14.684 14.016-33.512 23.723-54.461 27.098l-.504.082c-49.18-7.684-86.797-50.242-86.797-101.574V241.18c0-1.043.016-2.074.055-3.109 18.133 1.855 36.957-3.777 50.863-16.926 7.402-6.988 12.543-15.312 15.453-24.141 1.621 15.461 8.691 30.508 21.223 42.355 14.922 14.091 34.637 20.888 54.168 20.376z"
      />
      <path
        className="groups4_svg__st9"
        d="M309.453 271.653c0-9.434-7.645-17.078-17.074-17.078-9.434 0-17.078 7.645-17.078 17.078M233.18 271.653c0-9.434-7.645-17.078-17.078-17.078-9.43 0-17.074 7.645-17.074 17.078"
      />
      <path
        className="groups4_svg__st4"
        d="M227.766 278.922c0 6.441-5.223 11.664-11.664 11.664s-11.664-5.223-11.664-11.664 5.223-11.664 11.664-11.664 11.664 5.223 11.664 11.664zM304.043 278.922c0 6.441-5.223 11.664-11.664 11.664-6.445 0-11.664-5.223-11.664-11.664s5.219-11.664 11.664-11.664c6.441 0 11.664 5.223 11.664 11.664z"
      />
      <path
        className="groups4_svg__st9"
        d="M265.902 308.29h-23.328a5.03 5.03 0 110-10.062h23.328a5.03 5.03 0 015.031 5.031 5.027 5.027 0 01-5.031 5.031zM254.238 340.126c-8.609 0-17.219-2.16-25.066-6.473a4.571 4.571 0 01-1.805-6.211 4.57 4.57 0 016.211-1.805c12.938 7.113 28.387 7.113 41.324 0 2.211-1.219 4.992-.41 6.211 1.805s.41 4.992-1.805 6.211c-7.847 4.316-16.456 6.473-25.07 6.473z"
      />
      <path
        className="groups4_svg__st5"
        d="M225.387 276.864c0 2.762-2.234 4.996-4.996 4.996s-4.996-2.234-4.996-4.996 2.234-4.996 4.996-4.996 4.996 2.234 4.996 4.996zM302.234 276.864c0 2.762-2.234 4.996-4.996 4.996s-4.996-2.234-4.996-4.996 2.234-4.996 4.996-4.996 4.996 2.234 4.996 4.996z"
      />
      <path
        className="groups4_svg__st9"
        d="M324.223 307.333c0 7.074-5.734 12.809-12.809 12.809s-12.809-5.734-12.809-12.809 5.734-12.809 12.809-12.809 12.809 5.734 12.809 12.809zM209.867 307.333c0 7.074-5.734 12.809-12.809 12.809s-12.809-5.734-12.809-12.809 5.734-12.809 12.809-12.809 12.809 5.734 12.809 12.809z"
      />
    </g>
  </SvgIcon>
)

export default SvgGroups4
